import { render, staticRenderFns } from "./AdminShipperPrices.vue?vue&type=template&id=19ef2576"
import script from "./AdminShipperPrices.vue?vue&type=script&lang=js"
export * from "./AdminShipperPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ef2576')) {
      api.createRecord('19ef2576', component.options)
    } else {
      api.reload('19ef2576', component.options)
    }
    module.hot.accept("./AdminShipperPrices.vue?vue&type=template&id=19ef2576", function () {
      api.rerender('19ef2576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminShipperPrices.vue"
export default component.exports